<template>
  <div class="text-right">
    <Menu as="div" class="relative inline-block text-left">
      <div>
        <MenuButton
            class="btn btn-outline-dark inline-flex w-full justify-center rounded-md bg-black/20 px-4 py-2 text-xs font-medium text-white hover:bg-black/30 gap-2 items-center h-[32px]"
        >
          {{ buttonLabel }}
          <Icon icon="radix-icons:caret-down"/>
        </MenuButton>
      </div>

      <transition
          enter-active-class="transition duration-100 ease-out"
          enter-from-class="transform scale-95 opacity-0"
          enter-to-class="transform scale-100 opacity-100"
          leave-active-class="transition duration-75 ease-in"
          leave-from-class="transform scale-100 opacity-100"
          leave-to-class="transform scale-95 opacity-0"
      >
        <MenuItems
            class="absolute right-0 mt-2 min-w-72 origin-top-right rounded-lg bg-slate-800 z-10 shadow-2xl border border-slate-600">
          <div class="p-3">
            <MenuItem
                v-for="field in computedFields"
                :key="field.key"
                v-slot="{ active }"
            >
              <div
                  class="flex flex-row justify-between w-full group p-2 text-sm rounded-md gap-4 text-slate-200"
                  :class="[active ? 'bg-slate-700/20' : '', field.key === 'cut' ? '!text-red-400' : '', field.key === 'revenue' ? '!text-green-400' : '']"
              >
                <p>{{ field.label }}:</p>
                <p>{{ formatField(field) }}</p>
              </div>
            </MenuItem>
          </div>
        </MenuItems>
      </transition>
    </Menu>
  </div>
</template>

<script setup>
import {Menu, MenuButton, MenuItems, MenuItem} from '@headlessui/vue'
import {Icon} from '@iconify/vue'
import {computed} from 'vue'
import {useMainOrdersStore} from '@/stores/mainOrders.js'
import {formatPrice} from '@/utils/priceFormatter.js'

const props = defineProps({
  type: {type: String, required: true},
  orderType: {type: String, default: ''},
  buttonLabel: {type: String, default: 'Summary'},
  summeryType: {type: String, required: true}
})
const ordersStore = useMainOrdersStore()

const defaultFieldsMap = [
  {key: 'sold', label: 'Sold', suffix: '$'},
  {key: 'income', label: 'Income', suffix: '$'},
  {key: 'cut', label: 'Cut', suffix: '$'},
  {key: 'revenue', label: 'Revenue', suffix: '$'},
  {key: 'records', label: 'Records', suffix: ''},
]

const computedFields = computed(() => {
  return defaultFieldsMap || []
})

const summaryData = computed(() => {
  const name = props.orderType || (props.type.charAt(0).toUpperCase() + props.type.slice(1))
  return ordersStore.getSummary(props.type, name, props.summeryType) || {}
})

function formatField(field) {
  const raw = summaryData.value?.[field.key]
  const safe = raw == null ? 0 : raw
  const formatted = formatPrice(safe)
  return field.suffix ? `${formatted} ${field.suffix}` : formatted
}
</script>